import React, { useEffect, useState } from 'react';
import styles from './NewsCard.module.scss';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import togglerWhite from '../../../assets/Imagess/toggler-white.svg';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import renameIcon from '../../../assets/Imagess/rename-icon.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import uploadMedia from '../../../assets/Imagess/upload-media.svg';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../Custom/DeletePopup';
import EventInfoModal from './EventInfoModal';
import { useDeleteMediaGallery } from '../../../Hooks/Media';
import RenameMediaModal from './RenameMediaModal';
import Toggle from '../../Atoms/Inputs/Toggle';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import { useToast } from '../Custom/CustomToaster/Toast';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

function MediaCard({ media, refetchMedia, albumsCount }) {
  const [showInfo, setShowInfo] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const customizedToast = useToast();

  const {
    mutate: deleteEvent,
    isLoading: isDeletingEvent,
    isSuccess,
  } = useDeleteMediaGallery(media?.mediaGalleryId);

  useEffect(() => {
    if (isSuccess) {
      setShowDeletePopup(false);
      refetchMedia();
      customizedToast.open('تم الحذف بنجاح');
    }
  }, [isSuccess]);

  const menuItems = [
    {
      label: 'تعديل الألبوم',
      icon: renameIcon,
      onClick: () => {
        setShowRenameModal(true);
      },
    },
    {
      label: 'تحميل الوسائط',
      icon: uploadMedia,
      onClick: () => {
        navigate(`/home/media-gallery/${media?.mediaGalleryId}`);
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];
  return (
    <div
      className={styles['news-card']}
      style={{ position: 'relative', borderRadius: '28px' }}
    >
      <div
        className={styles['media-image-container']}
        onClick={() => navigate(`/home/media-gallery/${media?.mediaGalleryId}`)}
      >
        <img
          src={sanitizeAndValidateUrl(
            `${media?.images[0]?.url}${media?.images[0]?.imageURL}`
          )}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
          className={styles['news-card-image']}
          alt=''
        />

        <InfoButton
          icon={togglerWhite}
          className={styles['more-info']}
          data={menuItems}
          white={true}
        />
      </div>
      <div
        className={styles['news-card-info']}
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(`/home/media-gallery/${media?.mediaGalleryId}`)}
      >
        <div>
          <div className={styles['media-description']}>
            <p>{media?.galleryName_AR}</p>
          </div>
          <div className={styles['media-number']}>
            <p>{media?.images?.length} صور</p>
          </div>
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title='معرض الوسائط'
          handleDelete={() => {
            deleteEvent();
            refetchMedia();
          }}
          isLoading={isDeletingEvent}
        />
      )}
      {showInfo && (
        <EventInfoModal
          event={media}
          handleOnClose={() => setShowInfo(false)}
        />
      )}
      {showRenameModal && (
        <RenameMediaModal
          media={media}
          handleOnClose={() => setShowRenameModal(false)}
          refetchMedia={refetchMedia}
          albumsCount={albumsCount}
        />
      )}
    </div>
  );
}

export default MediaCard;
